<template>
  <div class="app-container">
    <div class="screen">
      <el-form
        label-width="200px"
        :inline="true"
        :model="screen"
        class="demo-form-inline"
        label-position="left"
      >
        <el-form-item label="选择园区">
          <el-select
            filterable
            v-model="screen.park_id"
            placeholder="请选择园区"
            :disabled="userInfo.park_id != 0"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="唯一编号">
          <el-input
            v-model="screen.task_day_num"
            placeholder="请输入唯一编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="模糊搜索">
          <el-input
            v-model="screen.search"
            placeholder="请输入搜索任务编号、执行人、执行角色、任务名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select
            filterable
            v-model="screen.status"
            placeholder="请选择状态"
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="完成" value="2"></el-option>
            <el-option label="未完成" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="巡检类型">
          <el-select
            filterable
            v-model="screen.type"
            placeholder="请选择巡检类型"
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="水" value="2"></el-option>
            <el-option label="电" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="使用状态">
          <el-select
            filterable
            v-model="screen.use_status"
            placeholder="请选择使用状态"
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="停用" value="2"></el-option>
            <el-option label="启用" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否关闭任务">
          <el-select
            filterable
            v-model="screen.close"
            placeholder="请选择是否关闭任务"
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="是" value="2"></el-option>
            <el-option label="否" value="1"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="计划开始时间">
          <el-date-picker
            v-model="screen.start_time"
            type="date"
            placeholder="计划开始时间"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="计划结束时间">
          <el-date-picker
            v-model="screen.end_time"
            type="date"
            placeholder="计划结束时间"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="实际任务开始时间">
          <el-date-picker
            v-model="screen.practical_start_time"
            type="date"
            placeholder="实际任务开始时间"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="实际任务结束时间">
          <el-date-picker
            v-model="screen.practical_end_time"
            type="date"
            placeholder="实际任务结束时间"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item> -->

        <el-form-item>
          <el-button
            size="medium"
            type="primary"
            @click="(screen.page = 1), fetchData()"
            >查询</el-button
          >
          <el-button size="medium" type="primary" plain @click="reset"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div style="margin-top: 10px">
      <el-button
        :disabled="multipleSelection.length == 0"
        v-if="roles.includes('/energy/task_day_close')"
        type="danger"
        @click="closeTask()"
        >批量关闭任务</el-button
      >
    </div>

    <el-table
      max-height="700"  v-loading="listLoading" 
      :data="list"
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column
        :selectable="selectable"
        type="selection"
        status="CheckFail"
        width="55"
      >
      </el-table-column>
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column label="所属园区" width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.snapshot">
            <span>{{
              scope.row.snapshot.park ? scope.row.snapshot.park.name : ""
            }}</span></span
          >
        </template>
      </el-table-column>
      <el-table-column label="类型" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.type == 1 ? "电" : "水" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="任务名称" align="center" width="150">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.snapshot.name }}</div>
        </template>
      </el-table-column>
      <el-table-column label="唯一编号" align="center" width="150">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.task_day_num }}</div>
        </template>
      </el-table-column>
      <el-table-column label="巡检人/角色" align="center" width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.snapshot.patrol_type == 2">
            <div
              :key="index"
              v-for="(item, index) in scope.row.snapshot.energy_task_user_rel"
            >
              <span v-if="index != 0">，</span> {{ item.systemRole.title }}
            </div>
          </span>
          <span v-if="scope.row.snapshot.patrol_type == 1">
            <div
              :key="index"
              v-for="(item, index) in scope.row.snapshot.energy_task_user_rel"
            >
              <span v-if="index != 0">，</span> {{ item.user.name }}
            </div>
          </span>
          <!-- <template v-if="scope.row.patrol_user.length > 0">
            
          </template>
          <template v-if="scope.row.patrol_role.length > 0">
            <div :key="index" v-for="(item, index) in scope.row.patrol_role">
              <span v-if="index != 0">，</span> {{ item.system_role.title }}
            </div>
          </template> -->
        </template>
      </el-table-column>
      <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.status == '2' ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.status == 2 ? "完成" : "未完成" }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="是否关闭任务" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.close == '1' ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.close == 1 ? "否" : "是" }}</el-tag
          >
        </template>
      </el-table-column>

      <el-table-column label="任务日期" align="center" width="180">
        <template slot-scope="scope">
          {{ scope.row.task_day_date }}
        </template>
      </el-table-column>
      <el-table-column label="计划开始时间" align="center" width="180">
        <template slot-scope="scope">
          {{ scope.row.start_date + "  " + scope.row.start_time }}
        </template>
      </el-table-column>
      <el-table-column label="计划结束时间" align="center" width="180">
        <template slot-scope="scope">
          {{ scope.row.end_date + "  " + scope.row.end_time }}
        </template>
      </el-table-column>
      <el-table-column label="实际开始时间" align="center" width="180">
        <template slot-scope="scope">
          {{ scope.row.practical_start_time }}
        </template>
      </el-table-column>
      <el-table-column label="实际结束时间" align="center" width="180">
        <template slot-scope="scope">
          {{ scope.row.practical_end_time }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="关闭原因" align="center" width="180">
        <template slot-scope="scope">
          {{
            scope.row.patrol_task_day_close
              ? scope.row.patrol_task_day_close.close_reason
              : ""
          }}
        </template>
      </el-table-column> -->
      <el-table-column
        align="center"
        prop="created_at"
        label="操作"
        width="200"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            @click="details(scope.row)"
            v-if="roles.includes('/energy/task_day_info')"
            >任务详情</el-button
          >
          <el-button
            size="mini"
            type="info"
            @click="schedule(scope.row.id)"
            v-if="roles.includes('/energy/task_day_progress')"
            >任务进度</el-button
          >
          <el-button
            style="margin-top: 10px"
            v-if="
              roles.includes('/energy/task_day_close') && scope.row.close == '1'
            "
            size="mini"
            type="danger"
            @click="closeTask(scope.row.id, 'single')"
            >关闭任务</el-button
          >
          <!-- <el-button
            style="margin-top: 10px"
            v-if="
              roles.includes('/patrol/task_day_open') && scope.row.close == '2'
            "
            size="mini"
            type="primary"
            @click="openTask(scope.row.id)"
            >开启任务</el-button
          > -->
          <!-- v-if="roles.includes('/patrol/task_day_close')" -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="800px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
        label-position="top"
      >
        <el-form-item label="选择园区" prop="park_id">
          <el-select
            filterable
            v-model="ruleForm.park_id"
            placeholder="请选择园区"
            disabled
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="巡检类型" prop="type">
          <el-radio-group v-model="ruleForm.type" disabled>
            <el-radio :label="1">电</el-radio>
            <el-radio :label="2">水</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="巡检任务" prop="energy_task_id">
          <el-select
            filterable
            v-model="ruleForm.energy_task_id"
            placeholder="请选择巡检路线"
            disabled
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in patrolPathList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="任务唯一编号" prop="task_day_num">
          <el-input
            class="w4"
            v-model="ruleForm.task_day_num"
            placeholder="请输入任务的唯一编号"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="任务有效时间">
          <el-date-picker
            v-model="timeData"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            disabled
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="ruleForm.status" disabled>
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="2">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="定期模式" prop="pattern">
          <el-radio-group v-model="ruleForm.pattern" disabled>
            <el-radio :label="1">月</el-radio>
            <el-radio :label="2">季</el-radio>
            <el-radio :label="3">年</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          :label="ruleForm.pattern == 1 ? '每月的第几天' : '每季的第几天'"
          v-if="ruleForm.pattern == 1 || ruleForm.pattern == 2"
        >
          <el-input-number
            v-model="dayNum"
            :disabled="cztype == 'see'"
            :step="1"
          ></el-input-number>
          <!-- <el-input
            class="w4"
            v-model="dayNum"
            placeholder="请输入账号名称"
            :disabled="cztype == 'see'"
          ></el-input> -->
        </el-form-item>
        <el-form-item label="开始日期" v-if="ruleForm.pattern == 3">
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="year_start_time"
            type="date"
            placeholder="选择日期"
            :disabled="cztype == 'see'"
          >
          </el-date-picker>
        </el-form-item>
        <div>
          <el-form-item label="开始时间" prop="status">
            <el-time-picker
              :disabled="cztype == 'see'"
              format="HH:mm:ss"
              value-format="HH:mm:ss"
              v-model="timeStr.start_time"
              placeholder="任意时间点"
            >
            </el-time-picker>
          </el-form-item>
          <el-form-item label="结束时间" prop="status">
            <el-time-picker
              :disabled="cztype == 'see'"
              format="HH:mm:ss"
              value-format="HH:mm:ss"
              v-model="timeStr.end_time"
              placeholder="任意时间点"
            >
            </el-time-picker>
          </el-form-item>
        </div>

        <el-form-item label="是否跳过周末" prop="is_skip_weekends">
          <el-radio-group
            v-model="ruleForm.is_skip_weekends"
            :disabled="cztype == 'see'"
          >
            <el-radio :label="1">跳过</el-radio>
            <el-radio :label="2">不跳过</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="持续时间" prop="duration_day">
          <el-input
            :disabled="cztype == 'see'"
            type="Number"
            class="w4 numInput"
            v-model="ruleForm.duration_day"
            placeholder="请输入持续时间"
            ><template slot="append">天</template></el-input
          >
        </el-form-item>
        <el-form-item label="是否跨域（跨天）">
          <el-radio-group
            :disabled="cztype == 'see'"
            filterable
            v-model="ruleForm.is_cross_origin"
            placeholder="请选择是否跨天"
          >
            <el-radio :label="1" :disabled="ruleForm.duration_day > 1"
              >否</el-radio
            >
            <el-radio :label="2" :disabled="ruleForm.duration_day <= 1"
              >是</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="is_share">
          <span slot="label">
            是否共享
            <el-tooltip
              content="开启后参与的巡检人可以共同完成该任务"
              effect="light"
              placement="top-start"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
          </span>
          <el-radio-group
            v-model="ruleForm.is_share"
            :disabled="cztype == 'see'"
          >
            <el-radio :label="1">否</el-radio>
            <el-radio :label="2">是</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="巡检人类型" prop="patrol_type">
          <el-radio-group
            v-model="ruleForm.patrol_type"
            :disabled="cztype == 'see'"
          >
            <el-radio :label="1">人</el-radio>
            <el-radio :label="2">角色</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="指定巡检人"
          :prop="
            ruleForm.patrol_type == 1 ? 'patrol_user_id' : 'patrol_role_id'
          "
        >
          <el-select
            filterable
            v-model="ruleForm.patrol_user_id"
            placeholder="指定巡检人"
            :disabled="cztype == 'see' || userInfo.park_id != 0"
            v-if="ruleForm.patrol_type == 1"
            :multiple="ruleForm.is_share == 2"
            collapse-tags
            @change="$forceUpdate()"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in userList"
              :key="index"
            ></el-option>
          </el-select>
          <el-select
            filterable
            v-model="ruleForm.patrol_role_id"
            placeholder="指定巡检人"
            :disabled="cztype == 'see' || userInfo.park_id != 0"
            v-if="ruleForm.patrol_type == 2"
            :multiple="ruleForm.is_share == 2"
            collapse-tags
            @change="$forceUpdate()"
          >
            <el-option
              :label="item.title"
              :value="item.id"
              v-for="(item, index) in roleList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </el-drawer>
    <el-drawer title="任务进度" :visible.sync="progressDrawer" size="800px">
      <el-table :data="progressList" style="width: 100%">
        <el-table-column align="center" label="序号" width="95">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="能耗名称" width="180">
        </el-table-column>
        <el-table-column prop="falg_status" label="状态" width="180">
          <template slot-scope="scope">
            <!-- <span>{{ scope.row.role_type == 1 ? '后台' : '小程序' }}</span> -->
            <el-tag
              :type="scope.row.falg_status == '已完成' ? 'success' : 'danger'"
              disable-transitions
              >{{
                scope.row.falg_status == "已完成" ? "已完成" : "未完成"
              }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column prop="degree" label="抄表数">
          <template slot-scope="scope">
            {{ scope.row.degree ? scope.row.degree : "--" }}
          </template>
        </el-table-column>
        <el-table-column prop="use_degree" label="使用度数">
          <template slot-scope="scope">
            <span>
              {{ scope.row.use_degree ? scope.row.use_degree : "--" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="抄表图" align="center" width="200">
          <template slot-scope="scope">
            <p v-if="scope.row.image">
              <el-image
                :src="imageOss + scope.row.image"
                class="tableIcon"
                fit="contain"
                :preview-src-list="$pathDispose(scope.row.image.split(','))"
              >
              </el-image>
            </p>
          </template>
        </el-table-column>
      </el-table>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  openPark,
  openPatrolPath,
  openAgoUser,
  openRole,
  closeTask,
  openDayTask,
  get_energy_task_lists,
} from "@/api/index";
import {
  taskDayLists,
  taskDayInfo,
  taskDayProgress,
  taskDayClose,
} from "@/api/energy";
import { getToken } from "@/utils/auth";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger",
      };
      return statusMap[status];
    },
  },
  data() {
    return {
      list: [],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加用户",
      token: getToken(),
      cztype: "",
      screen: {
        page: 1,
        page_size: 15,
        park_id: "",
        status: "",
        name: "",
        patrol_user: "",
        start_time: "",
        end_time: "",
        practical_start_time: "",
        practical_end_time: "",
      },
      total: 0,
      userList: [],
      patrolPathList: [],
      parkList: [],
      ruleForm: {},
      roleList: [],
      // 任务有效时间
      timeData: [],
      // 周期列表
      checkList: [],
      // 时间列表
      timeList: [
        {
          start_time: "",
          end_time: "",
        },
      ],
      // 第几天
      dayNum: 1,
      year_start_time: "",
      timeStr: {
        start_time: "",
        end_time: "",
      },
      progressDrawer: false,
      progressList: [],
      multipleSelection: [],
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
    } else {
      this.screen.park_id = "";
    }
    this.fetchData();
    this.getPark();
  },
  methods: {
    selectable(row, index) {
      if (row.close == 2) {
        return false;
      } else {
        return true;
      }
    },
    // 多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    openTask(id) {
      var that = this;
      this.$confirm("是否开启任务?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          openDayTask({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              that.fetchData();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    closeTask(id, type) {
      var that = this;
      let ids = [];
      if (type == "single") {
        ids.push(id);
      } else {
        this.multipleSelection.forEach((item) => {
          ids.push(item.id);
        });
      }
      // this.$confirm("是否关闭任务?", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      // })
      //   .then(() => {
      //     taskDayClose({ id: ids }).then((res) => {
      //       if (res.code == 200) {
      //         this.$message({
      //           type: "success",
      //           message: res.msg,
      //         });
      //         that.fetchData();
      //       } else {
      //         this.$message.error(res.msg);
      //       }
      //     });
      //  })
      //   .catch(() => {});
      this.$prompt("请输入关闭原因", "关闭", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          if (!value) {
            this.$message({
              type: "warning",
              message: "关闭原因不能为空！",
            });
            return;
          }
          taskDayClose({ id: ids, reason: value }).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              that.fetchData();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    schedule(id) {
      taskDayProgress({ id: id }).then((res) => {
        this.progressList = res.data.lists;
      });
      this.progressDrawer = true;
    },
    // 获取用户
    getAgoUser(id) {
      openAgoUser({ park_id: id, type: 1, is_page: 2,is_youke:2 }).then((res) => {
        this.userList = res.data.lists;
      });
    },
    // 获取任务路线
    getPath(id) {
      get_energy_task_lists({ park_id: id, is_page: 2 }).then((res) => {
        this.patrolPathList = res.data.lists;
      });
      // openPatrolPath({ park_id: id, is_page: 2 }).then((res) => {
      //   this.patrolPathList = res.data.lists;
      // });
    },
    // 获取角色
    getRole(id) {
      const data = {
        is_page: 2,
        is_tree: 1,
        park_id: id,
        type: 1,
      };
      openRole(data).then((res) => {
        this.roleList = res.data.lists;
      });
    },
    // 重置
    reset() {
      this.screen = {
        page: 1,
        page_size: 15,
        park_id: "",
        status: "",
        task_day_num: "",
        search: "",
        type: "",
        use_status: "",
        close: "",
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 查看
    details(val) {
      this.cztype = "see";
      this.drawerTitle = "任务详情";
      // this.ruleForm = val
      this.getInfo(val.id);
      this.getPath(val.park_id);
      this.getAgoUser(val.park_id);
      this.getRole(val.park_id);
      this.drawer = true;
    },
    getInfo(id, parkId) {
      this.dayNum = 1;
      this.year_start_time = "";
      var that = this;
      taskDayInfo({ id: id }).then((res) => {
        this.timeData = [];
        this.ruleForm = {
          id: res.data.info.id,
          park_id: res.data.info.park_id,
          task_day_num: res.data.info.task_day_num,
          energy_task_id: res.data.info.energy_task_id,
          start_date: res.data.info.start_date,
          end_date: res.data.info.end_date,
          patrol_type: res.data.info.patrol_type,
          patrol_user_id: res.data.info.patrol_user_id,
          patrol_role_id: res.data.info.patrol_role_id,
          status: res.data.info.status,
          pattern: res.data.info.pattern,
          system_admin_id: res.data.info.system_admin_id,
          is_share: res.data.info.is_share,
          duration_day: res.data.info.duration_day,
          is_skip_weekends: res.data.info.snapshot.is_skip_weekends,
          is_cross_origin: res.data.info.is_cross_origin,
          patrol_type: res.data.info.snapshot.patrol_type,
          type: res.data.info.type,
        };
        // if (res.data.info.snapshot.patrol_type == 1) {
        //   this.ruleForm.patrol_role_id = "";
        // } else {
        //   this.ruleForm.patrol_user_id = "";
        // }
        if (res.data.info.pattern == 3) {
          this.year_start_time = Object.keys(
            res.data.info.snapshot.patrol_pattern_json
          )[0];
          this.timeStr =
            res.data.info.snapshot.patrol_pattern_json[this.year_start_time];
        } else {
          this.dayNum = Object.keys(
            res.data.info.snapshot.patrol_pattern_json
          )[0];
          this.timeStr =
            res.data.info.snapshot.patrol_pattern_json[this.dayNum];
        }
        this.ruleForm.patrol_role_id = [];
        this.ruleForm.patrol_user_id = [];
        if (res.data.info.snapshot.patrol_type == 1) {
          res.data.info.snapshot.energy_task_user_rel.forEach((item, index) => {
            this.ruleForm.patrol_user_id.push(item.user_id);
          });
        } else {
          res.data.info.snapshot.energy_task_user_rel.forEach((item, index) => {
            this.ruleForm.patrol_role_id.push(item.system_role_id);
          });
        }
        if (res.data.info.snapshot.is_share == 1) {
          this.ruleForm.patrol_user_id = Number(
            this.ruleForm.patrol_user_id.toString()
          );
          this.ruleForm.patrol_role_id = Number(
            this.ruleForm.patrol_role_id.toString()
          );
        }
        // if (res.data.info.is_share == 1) {
        //   this.ruleForm.patrol_role_id = res.data.info.snapshot.patrol_role_id;
        //   this.ruleForm.patrol_user_id = res.data.info.snapshot.patrol_user_id;
        // } else {
        //   this.ruleForm.patrol_role_id = [];
        //   this.ruleForm.patrol_user_id = [];
        //   if (res.data.info.snapshot.patrol_type == 1) {
        //     res.data.info.snapshot.energy_task_user_rel.forEach((item, index) => {
        //       this.ruleForm.patrol_user_id.push(item.user_id);
        //     });
        //   } else {
        //     res.data.info.snapshot.energy_task_user_rel.forEach((item, index) => {
        //       this.ruleForm.patrol_role_id.push(item.system_role_id);
        //     });
        //   }
        // }
        this.timeData.push(res.data.info.start_date);
        this.timeData.push(res.data.info.end_date);
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    // 获取园区
    getPark() {
      openPark({ is_page: 2, status: 1,id:this.screen.park_id,source:'energy'}).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    fetchData() {
      this.listLoading = true;
      taskDayLists(this.screen).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding: 0 20px;
  overflow: auto;
}

.table-box {
  margin-top: 20px;
}
.avatar-uploader {
  width: 60px;
  height: 60px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 70px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin: 0 10px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
::v-deep .screen {
  padding: 0 50px;
  border-bottom: 1px solid #e4e7ed;
  .el-input {
    width: 200px;
  }
  .el-form--inline .el-form-item {
    width: 23%;
  }
}
.headbox {
  display: flex;
  justify-content: space-between;
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
</style>
